// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2YCcC","info":"Note_info__1Y9Go","note":"Note_note__3Wb4E","actions":"Note_actions__SLgzg"};